var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4076 10.5933L22.6723 7.32861C24.0057 5.99528 24.6723 5.32861 25.5007 5.32861C26.3292 5.32861 26.9958 5.99528 28.3292 7.32861L28.6723 7.67176C30.0057 9.00509 30.6723 9.67176 30.6723 10.5002C30.6723 11.3286 30.0057 11.9953 28.6723 13.3286L28.6723 13.3286L25.4405 16.5605C22.9461 15.1149 20.8713 13.0557 19.4076 10.5933ZM17.9533 12.0476L6.85713 23.1438C6.43207 23.5689 6.21954 23.7814 6.0798 24.0425C5.94007 24.3036 5.88112 24.5983 5.76323 25.1878L4.64784 30.7648C4.58131 31.0974 4.54805 31.2637 4.64266 31.3583C4.73727 31.4529 4.90357 31.4196 5.23618 31.3531L10.8132 30.2377C11.4026 30.1198 11.6973 30.0609 11.9584 29.9211C12.2195 29.7814 12.4321 29.5689 12.8571 29.1438L23.9825 18.0185C21.5389 16.5088 19.4784 14.4627 17.9533 12.0476Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/editWhite.271e8a1715c7ad9c25cd5179a3f5f33f.svg";
export { ForwardRef as ReactComponent };